import { Component } from "solid-js";

interface HomeDecorIconProps {
  class?: string;
}

export const HomeDecorIcon: Component<HomeDecorIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M13.3323 26.6711V20.0016C13.3323 19.2649 13.9295 18.6677 14.6662 18.6677H17.3339"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.99512 14.1062L14.2639 5.30413C15.263 4.44778 16.7372 4.44778 17.7363 5.30413L28.0051 14.1062"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.0001 26.6711H3.99512"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.8335 7.95901V4.99535C20.8335 4.44284 21.2814 3.99493 21.8339 3.99493H25.2899C25.8424 3.99493 26.2903 4.44284 26.2903 4.99535V12.6364"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.70967 12.6364V26.6711"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.6703 28.0049C24.6703 25.4265 22.5801 23.3363 20.0017 23.3363C22.5801 23.3363 24.6703 21.2461 24.6703 18.6677C24.6703 21.2461 26.7605 23.3363 29.3389 23.3363C26.7605 23.3363 24.6703 25.4265 24.6703 28.0049Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
